import Vue from 'vue'
import Element from 'element-ui'
import store from './store'
import './plugins'
import '../global.css'
import './permission'
import App from './App'
import router from './router'

import { COMPANY_NAME, COMPANY_SHORT_NAME } from '@/constants'
Vue.prototype.$companyShortName = COMPANY_SHORT_NAME
Vue.prototype.$companyName = COMPANY_NAME
// 修改 MessageBox 默认点击遮罩层为不关闭
Element.MessageBox.setDefaults({
  closeOnClickModal: false
})
// 修改 el-dialog 默认点击遮照为不关闭
Element.Dialog.props.closeOnClickModal.default = false
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js